import React from "react";
import { isNil } from "ramda";
import Plot from "react-plotly.js";

const WaterfallChart = ({ prefix, data, configData, intl }) => {
  const HeatMap = () => {
    const heatMapData = data?.series?.map((s) => ({
      ...s,
    }));
    const toPlotlyColorscale = (cm, maxStops = 64) => {
      const { red, green, blue, value } = cm;
      const n = value.length;
      const step = Math.max(1, Math.floor(n / maxStops));

      const indexes = [];
      for (let i = 0; i < n; i += step) indexes.push(i);
      if (indexes[indexes.length - 1] !== n - 1) indexes.push(n - 1);

      return indexes.map((i, k) => [
        k === 0 ? 0 : k === indexes.length - 1 ? 1 : value[i], // Plotly exige empezar en 0 y acabar en 1
        `rgb(${Math.round(red[i] * 255)},${Math.round(green[i] * 255)},${Math.round(blue[i] * 255)})`,
      ]);
    };

    const resolveColorscale = (name, colorMaps) => {
      if (isNil(name)) return undefined;
      const cm = colorMaps?.[name];
      if (cm?.red && cm?.green && cm?.blue && cm?.value) return toPlotlyColorscale(cm);
      return name.charAt(0).toUpperCase() + name.slice(1); // fallback: nombres nativos de Plotly (jet -> Jet)
    };
    const scale = !isNil(configData)
      ? resolveColorscale(data?.graphic, configData.colorMaps)
      : data?.graphic?.charAt(0).toUpperCase() + data?.graphic?.slice(1);
    if (isNil(heatMapData)) {
      return null;
    }
    const layout = {
      title: data.title,
      xaxis: {
        title: { text: data.xAxis.text, standoff: 10 },
        type: data.xAxis.type,
        tickformatstops:
          data.xAxis.type === "date"
            ? [
                {
                  dtickrange: [null, "D1"], // alejado → días
                  value: "%Y/%m/%d",
                },
                {
                  dtickrange: ["D1", "h1"], // acercando → horas
                  value: "%Y/%m/%d %Hh",
                },
                {
                  dtickrange: ["h1", null], // zoom fuerte → minutos
                  value: "%Y/%m/%d %H:%M",
                },
              ]
            : null,
        tickangle: 0,
        automargin: true,
      },
      yaxis: {
        title: {
          text: data.yAxis.text,
          standoff: 10,
        },
        type: data.yAxis.type,
        tickformatstops:
          data.yAxis.type === "date"
            ? [
                {
                  dtickrange: [null, "D1"], // alejado → días
                  value: "%Y/%m/%d",
                },
                {
                  dtickrange: ["D1", "h1"], // acercando → horas
                  value: "%Y/%m/%d %Hh",
                },
                {
                  dtickrange: ["h1", null], // zoom fuerte → minutos
                  value: "%Y/%m/%d %H:%M",
                },
              ]
            : null,
        automargin: true,
      },
      paper_bgcolor: "transparent",
      plot_bgcolor: "transparent",
      margin: { l: 0, r: 0, t: 25, b: 0 },
    };
    return (
      <Plot
        data={[
          {
            z: heatMapData[0].data,
            x: data.xAxis.data,
            y: data.yAxis.data,
            type: "heatmap",
            colorscale: scale,
            zmin: data.limits.min, // mínimo valor permitido
            zmax: data.limits.max, // máximo valor permitido
          },
        ]}
        layout={layout}
        style={{ width: "100%", height: "500px" }}
      />
    );
  };
  return (
    <div style={{ overflow: "hidden" }}>
      <HeatMap />
    </div>
  );
};

export default WaterfallChart;
